import GenericStore, { UIDMethod } from '@/generic_api/lib/generic_store/GenericStore'

import exampleModelDefinition from './example';
import sequenceModelDefinition from './sequence';
import sequenceItemModelDefinition from './sequence/sequenceItem';
import sequenceActionModelDefinition from './sequence/sequenceAction';
import ideaModelDefinition from './idea';
import featureModelDefinition from './feature';
import userdirectoryModelDefinition from './userdirectory';
import invitationModelDefinition from './invitation';

import userAbtractDefinition from './user'
import userReadonlyModelDefinition from './user/userReadonly';
import userStatusModelDefinition from './user/userStatus';
import userPublicModelDefinition from './user/userPublic';

import userSettingsModelDefinition from './user/userSettings';

import userGoalSettingsModelDefinition from './user/userGoalSettings';
import userGoalCategoryModelDefinition from './user/userGoalCategory';
import userCommitmentSettingsModelDefinition from './user/userCommitmentSettings';
import userSequenceSettingsModelDefinition from './user/userSequenceSettings';
import userChallengeSettingsModelDefinition from './user/userChallengeSettings';
import userVisionboardSettingsModelDefinition from './user/userVisionboardSettings';

import userContactModelDefinition from './user/userContact';
import userAnalysisLogModelDefinition from './user/userAnalysisLog';
import userDailyTargetsAndSummaryModelDefinition from './user/userDailyTargetsAndSummary'
import userTimerModelDefinition from './user/userTimer';

import userDayplannerSessionsModelDefinition from './user/userDayplannerSessions';
import userDayplannerTasksModelDefinition from './user/userDayplannerTasks';
//import userDayplannerSessionsItemModelDefinition from './user/userDayplannerSessionsItem';

import userOutgoingInvitationModelDefinition from './user/userOutgoingInvitation';
import userIncommingInvitationModelDefinition from './user/userIncommingInvitation';
import userMsgInboxModelDefinition from './user/userMsgInbox';
import userNotificationInboxModelDefinition from './user/userNotificationInbox';

import timeslotCollectionModelDefinition from './timeslotCollection';
import timeslotExceptionModelDefinition from './timeslotCollection/timeslotException';
import timeslotWeekdayPrefModelDefinition from './timeslotCollection/timeslotWeekdayPref'

import calendarItemModelDefinition from './calendar/calendarItem';

import goalAbtractDefinition from './goal'
import activityModelDefinition from './goal/activity';
import goalDeadlineModelDefinition from './goal/goalDeadline';
import goalMetaModelDefinition from './goal/goalMeta';
import goalMemberModelDefinition from './goal/goalMember';
import goalMemberPrivacySettingsModelDefinition from './goal/goalMemberPrivacySettings';
import commitmentMetaModelDefinition from './goal/commitmentMeta';
import commitmentCategoryModelDefinition from './goal/commitmentCategory';

import challengeModelDefinition from './challenge';
import challengeInternalModelDefinition from './challenge/challengeInternal';
import challengeSuccessStoryModelDefinition from './challenge/challengeSuccessStory';
import challengeCommentModelDefinition from './challenge/challengeComment';

import cohortModelDefinition from './cohort';
import cohortActivityModelDefinition from './cohort/cohortActivity';
import cohortSessionModelDefinition from './cohort/cohortSession';
import cohortSessionCommentModelDefinition from './cohort/cohortSessionComment';

import commitmentModelDefinition from './commitment';
import commitmentTaskFinishDatesModelDefinition from './commitment/commitmentTaskFinishDates';
import commitmentSequenceTasksModelDefinition from './commitment/commitmentSequenceTasks';
import commitmentSessionModelDefinition from './commitment/commitmentSession';
import commitmentDailySettingsItemModelDefinition from './commitment/commitmentDailySettingsItem';
import commitmentDailySettingsModelDefinition from './commitment/commitmentDailySettings';

import taskAbstractDefinition from './task';
import taskDetailsModelDefinition from './task/taskDetails';
import taskMetaModelDefinition from './task/taskMeta';
import taskSubscriptionModelDefinition from './task/taskSubscription';
import taskChecklistItemModelDefinition from './task/taskChecklistItem';
import taskCommentModelDefinition from './task/taskComment';
import taskNameModelDefinition from './task/taskName';
import taskRecordedSessionModelDefinition from './task/taskRecordedSession';

import visionboardModelDefinition from './visionboard';
// import visionboardGoalRepresentationModelDefinition from './visionboard/goalRepresentation';
// import visionboardCommitmentRepresentationModelDefinition from './visionboard/commitmentRepresentation';
// import visionboardFeatureModelDefinition from './visionboard/feature';

// ------------------------------------------------------------------------ MISC

export const example = new GenericStore(
  "/example/*",
  exampleModelDefinition
);

export const feature = new GenericStore(
  "/feature/*",
  featureModelDefinition
);

export const userdirectory = new GenericStore(
  "/userdirectory/*",
  userdirectoryModelDefinition,
  { uidMethod: UIDMethod.PUSHID } // TODO: or even slug id?
  // { uidMethod: UIDMethod.MY_USER_ID } << has to be pushid
);

export const invitation = new GenericStore(
  "/invitation/{email}/*",
  invitationModelDefinition,
  { uidMethod: () => ( "" + Math.random() ).substring(2,8) } // UIDMethod.INVITATION_CODE
);

// ------------------------------------------------------------------------ USER

export const user = new GenericStore(
  "/user/*",
  userAbtractDefinition,
  { isAbstract: true }
);

let isAdmin = true // TODO: set to false, when all users are converted

export const userReadonly = new GenericStore(
  "/user/*/readonly",
  userReadonlyModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID, isReadonly: !isAdmin }
);

export const userStatus = new GenericStore(
  "/user/*/status",
  userStatusModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID }
);

export const userPublic = new GenericStore(
  "/user/*/public",
  userPublicModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID }
);

export const userSettings = new GenericStore(
  "/user/*/settings",
  userSettingsModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID }
);

export const userGoalCategory = new GenericStore(
  "/user/{uid}/goal_category/*",
  userGoalCategoryModelDefinition,
);

export const userGoalSettings = new GenericStore(
  "/user/{uid}/goal_settings/*",
  userGoalSettingsModelDefinition,
  // { uidMethod: (props) => props['goalId'] }
);

export const userCommitmentSettings = new GenericStore(
  "/user/{uid}/commitment_settings/*",
  userCommitmentSettingsModelDefinition,
  // { uidMethod: (props) => props['commitmentId'] }
);

export const userSequenceSettings = new GenericStore(
  "/user/{uid}/sequence_settings/*",
  userSequenceSettingsModelDefinition,
  // { uidMethod: (props) => props['sequenceId'] }
);

export const userChallengeSettings = new GenericStore(
  "/user/{uid}/challenge_settings/*",
  userChallengeSettingsModelDefinition
  // { uidMethod: (props) => props['challengeId'] }
);

export const userVisionboardSettings = new GenericStore(
  "/user/{uid}/visionboard_settings/*",
  userVisionboardSettingsModelDefinition
  // { uidMethod: (props) => props['visionboardId'] }
);

export const userContact = new GenericStore(
  "/user/{uid}/contacts/*",
  userContactModelDefinition,
  { uidMethod: (props) => props['otherUserId'] }
);

export const userDailyTargetsAndSummary = new GenericStore(
  "/user/{uid}/daily_targets/*",
  userDailyTargetsAndSummaryModelDefinition,
  { uidMethod: UIDMethod.DATE }
);

export const userAnalysisLog = new GenericStore(
  "/user/{uid}/analysis_log/*",
  userAnalysisLogModelDefinition,
  { uidMethod: UIDMethod.DATE }
);

export const userTimer = new GenericStore(
  "/user/*/timer",
  userTimerModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID }
);

export const userOutgoingInvitation = new GenericStore(
  "/user/{uid}/outgoing_invitations/*",
  userOutgoingInvitationModelDefinition,
);

export const userIncommingInvitation = new GenericStore(
  "/user/{uid}/incomming_invitations/*",
  userIncommingInvitationModelDefinition,
);

export const userDayplannerSessions = new GenericStore(
  "/user/{uid}/dayplanner/*",
  userDayplannerSessionsModelDefinition
);

export const userDayplannerTasks = new GenericStore(
  "/user/{uid}/dayplanner_tasks/*",
  userDayplannerTasksModelDefinition
);

/*export const userDayplannerSessionsItem = new GenericStore(
  "/user/{uid}/dayplanner/{dateString}/*",
  userDayplannerSessionsItemModelDefinition
);*/

export const userMsgInbox = new GenericStore(
  "/user/{uid}/msginbox/*",
  // "/user/{uid}/msginbox/{senderUserId}/*"
  userMsgInboxModelDefinition,
);

export const userNotificationInbox = new GenericStore(
  "/user/{uid}/notifications/*",
  userNotificationInboxModelDefinition,
);

export const idea = new GenericStore(
  "/user/{uid}/ideas/*",
  ideaModelDefinition
);

// ---------------------------------------------------------------------TIMESLOT

export const timeslotCollection = new GenericStore(
  "/user/{uid}/timeslot_collections/*",
  timeslotCollectionModelDefinition
);

// TODO !!! move on level up, so we can do subscribeQuery !!!
// /user/{uid}/exception_list/* + field timeslotCollectionId
export const timeslotException = new GenericStore(
  // "/user/{uid}/timeslot_collections/{timeslotCollectionId}/exception_list/*",
  "/user/{uid}/timeslot_exception_list/*",
  timeslotExceptionModelDefinition
);

// TODO !!! move on level up, so we can do subscribeQuery !!!
// /user/{uid}/weekday_preferences/* + field timeslotCollectionId
export const timeslotWeekdayPref = new GenericStore(
  // "/user/{uid}/timeslot_collections/{timeslotCollectionId}/weekday_preferences/*",
  "/user/{uid}/timeslot_weekday_preferences/*",
  timeslotWeekdayPrefModelDefinition
);

// -------------------------------------------------------------------- CALENDAR

export const calendarItem = new GenericStore(
  "/user/{uid}/calendar_items/*",
  calendarItemModelDefinition
);

// ------------------------------------------------------------------------ GOAL

export const goal = new GenericStore(
  "/goal/*",
  goalAbtractDefinition,
  { isAbstract: true }
);

export const goalMeta = new GenericStore(
  '/goal/*/meta',
  goalMetaModelDefinition
);

export const goalDeadline = new GenericStore(
  "/goal/{goalId}/meta/deadlineList/*",
  goalDeadlineModelDefinition
);

export const goalMember = new GenericStore(
  "/goal/{goalId}/meta/members/*",
  // "/goal/{goalId}/members/*",
  goalMemberModelDefinition,
  { uidMethod: UIDMethod.MY_USER_ID }
);

export const goalMemberPrivacySettings = new GenericStore(
  "/goal/{goalId}/meta/members/{memberId}/privacy_settings/*",
  goalMemberPrivacySettingsModelDefinition,
  { uidMethod: UIDMethod.OTHER_USER_ID }
);

export const commitmentMeta = new GenericStore(
  '/goal/{goalId}/meta/commitment_meta/*',
  commitmentMetaModelDefinition,
  // ID -> commitmentId
);

export const commitment = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/commitments/*",
  commitmentModelDefinition
  // ID -> commitmentId
);

export const commitmentCategory = new GenericStore(
  '/goal/{goalId}/meta/commitment_category/*',
  commitmentCategoryModelDefinition
);

export const commitmentDailySettings = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/commitment_daily_settings/*",
  commitmentDailySettingsModelDefinition,
  { isReadonly: true }
);

export const commitmentDailySettingsItem = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/commitment_daily_settings/{dateString}/*",
  commitmentDailySettingsItemModelDefinition,
  { uidMethod: (props) => props['commitmentId'] }
);

// TODO: commitmentTaskFinishDates -> commitmentTaskFinishDateList
export const commitmentTaskFinishDates = new GenericStore( // --> task_end_dates?
  "/goal/{goalId}/commitment_task_finish_dates/*",
  commitmentTaskFinishDatesModelDefinition,
  { uidMethod: (props) => props['commitmentId'] }
);

export const commitmentSequenceTasks = new GenericStore( // --> task_end_dates?
  "/goal/{goalId}/user_list/{uid}/commitment_sequence_tasks/*",
  commitmentSequenceTasksModelDefinition
);

export const commitmentSession = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/commitment_sessions/*",
  commitmentSessionModelDefinition
);

export const task = new GenericStore(
  '{goalId},{memberId}', // Allow paths for abstract stores
  taskAbstractDefinition
  // TODO: isAbstract, isReadonly
);

export const taskMeta = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_meta/*",
  taskMetaModelDefinition
);

export const taskName = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_names/*",
  taskNameModelDefinition,
  { uidMethod: (props) => props['taskId'] } // TODO: Show warning to user, that prop needs to be defined
);

export const taskDetails = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_details/*",
  taskDetailsModelDefinition,
  { uidMethod: (props) => props['taskId'] } // TODO: Show warning to user, that prop needs to be defined
);

export const taskSubscription = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_details/*/task_subscription",
  taskSubscriptionModelDefinition
);

export const taskChecklistItem = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_details/{taskId}/checklist/*",
  taskChecklistItemModelDefinition
);

export const taskComment = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/task_details/{taskId}/comment/*",
  taskCommentModelDefinition
);

export const taskRecordedSession = new GenericStore(
  "/goal/{goalId}/user_list/{uid}/recorded_sessions/*",
  taskRecordedSessionModelDefinition,
  { uidMethod: UIDMethod.LOCAL_TIMESTAMP }
);

export const activity = new GenericStore(
  "/goal/{goalId}/activities/*",
  activityModelDefinition
);

// ------------------------------------------------------------------- CHALLENGE

export const challengesPublic = new GenericStore(
  '/challenge_public/*',
  challengeModelDefinition
);

export const challengeTemplate = new GenericStore(
  '/challenge/{challengeId}/commitment_template/*',
  // challengeTemplateDefinition
  commitmentModelDefinition // !!! TODO
);

export const challengeInternal = new GenericStore(
  "/challenge/*/internal", // ..."meta"
  challengeInternalModelDefinition
);

export const challengeSuccessStory = new GenericStore(
  "/challenge/{challengeId}/success_stories/*",
  challengeSuccessStoryModelDefinition
);

export const challengeComment = new GenericStore(
  "/challenge/{challengeId}/challenge_comments/*",
  challengeCommentModelDefinition
);

export const cohort = new GenericStore(
  "/challenge/{challengeId}/cohorts/*",
  cohortModelDefinition
);

export const cohortActivity = new GenericStore(
  "/challenge/{challengeId}/cohorts/{cohortId}/activities/*",
  cohortActivityModelDefinition
);

export const cohortSession = new GenericStore(
  "/challenge/{challengeId}/cohorts/{cohortId}/sessions/*",
  cohortSessionModelDefinition
);

export const cohortSessionComment = new GenericStore(
  "/challenge/{challengeId}/cohorts/{cohortId}/sessions/{sessionId}/comments/*",
  cohortSessionCommentModelDefinition
);

// -------------------------------------------------------------------- SEQUENCE

export const sequence = new GenericStore(
  "/sequence/*",
  sequenceModelDefinition
);

export const sequenceItem = new GenericStore(
  "/sequence/{sequenceId}/sequenceItemList/*",
  sequenceItemModelDefinition,
  { uidMethod: UIDMethod.ARRAY }
);

export const sequenceAction = new GenericStore(
  "/sequence/{sequenceId}/sequenceItemList/{sequenceItemId}/actions/*",
  sequenceActionModelDefinition,
  { uidMethod: UIDMethod.ARRAY }
);

// ----------------------------------------------------------------- VISIONBOARD

export const visionboard = new GenericStore(
  "/visionboard/*",
  visionboardModelDefinition
);

/*
export const visionboardGoal = new GenericStore(
  "/visionboard/{visionboardId}/goals",
  visionboardGoalRepresentationModelDefinition
);

export const visionboardCommitment = new GenericStore(
  "/visionboard/{visionboardId}/commitments",
  visionboardCommitmentRepresentationModelDefinition
);

export const visionboardFeature = new GenericStore(
  "/visionboard/{visionboardId}/commitments",
  visionboardFeatureModelDefinition
);
*/

// ------------------------------------------------------------------------ MISC
/* Keep store reference in _prototype */
export const _prototype = {
  setName(msg) {
    delete this['setName']
  },
  GenericStore: GenericStore,
  setDefaultDB: (db) => { GenericStore.setDefaultDB(db) },
  setDefaultUser: (id) => { GenericStore.defaultUserId = id },
}

// ------------------------------------------------------------------------- END

// TODO:
// replace goalId etc. with goal_id -> this allows often to replace
// example.with({ goalId: goal_id }) with example.with({goal_id})

/*
export const $master = {
  masterGoals: new GenericStore(
    null,
    null, // masterGoalsModelDefinition
  ),
  masterCalendar: new GenericStore(
    null,
    null, // masterCalendarsModelDefinition
  ),
}
*/
